import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _slicedToArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.math.sign.js";
import "core-js/modules/es6.number.parse-float.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import camelCase from 'lodash/camelCase';
import moment from 'moment';
import { store } from "../../index";
import { FIB } from '@/config/constants';
var QUESTION_TYPE = FIB.QUESTION_TYPE;
import { passesIndicatorRule } from '@/store/helpers/rules';
import otherQuestionUtils, { getTriggerAnswers } from "./_otherQuestionUtils";
import Logger from 'js-logger';
var type = QUESTION_TYPE.QUESTION_TYPE_CONTEXT; // The following are common implementations to context filters.

var filterImpls = {
  /**
   * Helper to determine the allowed comparisons for a given context filter.
   * This will convert something like 'ge' to [ 1, 0 ]
   *
   * @param {Object} filter
   *
   * @returns {Array}
   */
  __getAllowedComparisons: function __getAllowedComparisons(filter) {
    var comparisonResults = {
      g: 1,
      e: 0,
      l: -1
    };
    return (filter.direction || '').split('').map(function (a) {
      return comparisonResults[a];
    }).filter(function (r) {
      return r != null;
    });
  },

  /**
   * Compare a numeric-based filter to its relevant target
   *
   * @param {Object} context
   * @param {Object} context.filter
   * @param {String|Number|Null} target
   *
   * @returns {Boolean}
   */
  numeric: function numeric(_ref, target) {
    var filter = _ref.filter;

    // Return false if the target or filter value is null/undefined.
    if (target == null || filter.value == null) {
      return false;
    } // Compute the comparison between the target and the filter value.


    var comparison = Math.sign(Number.parseFloat(target) - Number.parseFloat(filter.value));

    var allowedComparisons = filterImpls.__getAllowedComparisons(filter); // Return true iff the comparison result is in the allowed set.


    return allowedComparisons.includes(comparison);
  },

  /**
   * Compare a time-based filter to its relevant target
   *
   * @param {Object} context
   * @param {Object} context.filter
   * @param {String} target
   *
   * @returns {Boolean}
   */
  time: function time(_ref2, target) {
    var filter = _ref2.filter;

    var timestamp = function timestamp(s) {
      return moment(s).isValid() ? moment(s).valueOf() : null;
    }; // We convert the filter value and the targetted date to today's,
    // so any datetime comparison is really time comparison only - which is
    // what we want.. Moment.js doesn't provide a super simple way of doing this.
    // First let's validate the filter value, and reduce it to today's timestamp:


    var _filter$value$split = filter.value.split(':'),
        _filter$value$split2 = _slicedToArray(_filter$value$split, 2),
        hours = _filter$value$split2[0],
        minutes = _filter$value$split2[1];

    if (hours == null || minutes == null) {
      return false;
    }

    filter.value = timestamp({
      h: hours,
      m: minutes
    }); // Validate the target, and reduce it to today's timestamp:

    if (target == null) {
      return false;
    }

    target = moment(target);

    if (!target.isValid()) {
      return false;
    }

    return filterImpls.numeric({
      filter: filter
    }, timestamp({
      h: target.hours(),
      m: target.minutes()
    }));
  },

  /**
   * Compare a day-of-week based filter to its relevant target
   *
   * @param {Object} context
   * @param {Object} context.filter
   * @param {String} target
   *
   * @returns {Boolean}
   */
  dow: function dow(_ref3, target) {
    var filter = _ref3.filter;
    // filter.value lists allowed dows in MySQL DAYOFWEEK format, which is 1 = Sunday to 7 = Saturday
    var allowedDays = (filter.value || '').split('').map(function (r) {
      return parseInt(r);
    }); // Validate target:

    if (target == null) {
      return false;
    }

    target = moment(target);

    if (!target.isValid()) {
      return false;
    } // moment.day() uses the 0 = Sunday to 6 = Saturday format, so to be compatible, we need to add 1.
    // (https://momentjscom.readthedocs.io/en/latest/moment/02-get-set/06-day/)


    var targetDow = target.day() + 1; // The filter passes if the targetted value is in the list of allowed days.

    return allowedDays.includes(targetDow);
  }
}; // Currently defined context filters, selectable on the front end.
// Please only add properties to this which match up to the front-end.

var allContextFilters = {
  numInParty: function numInParty(context) {
    var _context$check;

    return filterImpls.numeric(context, (_context$check = context.check) === null || _context$check === void 0 ? void 0 : _context$check.covers);
  },
  totalAmountSpent: function totalAmountSpent(context) {
    var _context$check2;

    return filterImpls.numeric(context, (_context$check2 = context.check) === null || _context$check2 === void 0 ? void 0 : _context$check2.subtotal);
  },
  averageSpentPerHead: function averageSpentPerHead(context) {
    var _context$check3;

    return filterImpls.numeric(context, (_context$check3 = context.check) === null || _context$check3 === void 0 ? void 0 : _context$check3.avgSpentPerHead);
  },
  timeOfDay: function timeOfDay(context) {
    var _context$check4;

    return filterImpls.time(context, (_context$check4 = context.check) === null || _context$check4 === void 0 ? void 0 : _context$check4.checkOpenTime);
  },
  dayOfWeek: function dayOfWeek(context) {
    var _context$check5;

    return filterImpls.dow(context, (_context$check5 = context.check) === null || _context$check5 === void 0 ? void 0 : _context$check5.checkOpenTime);
  }
};
/**
 * Apply all Context Sensitive context filters to a question against the current context to determine
 * if the question should be selected.
 *
 * @param {Object} context
 *
 * @returns {Boolean}
 */

function applyContextFilters(context) {
  var _store$getters$checkI, _store$getters$checkI2;

  var check = (_store$getters$checkI = store.getters['checkIn/eposData']) === null || _store$getters$checkI === void 0 ? void 0 : (_store$getters$checkI2 = _store$getters$checkI.transaction) === null || _store$getters$checkI2 === void 0 ? void 0 : _store$getters$checkI2.check;
  var contextFilters = context.question.contextFilters || []; // Every filter need to be passed in order for the question to be selected

  return contextFilters.every(function (filter) {
    var filterType = camelCase(filter.type);
    Logger.debug("Context Sensitive: Applying filter ".concat(filterType)); // Find the filter in allContextFilters

    var contextFilter = allContextFilters[filterType]; // If we don't support a given type, ignore it by saying that it passed the filter (which
    // seems a little backwards, but it's correct behaviour).

    if (!contextFilter) {
      Logger.debug("Context Sensitive: Ignoring unknown context filter ".concat(filter.type));
      return true;
    } // Apply the context filter.


    return contextFilter(_objectSpread(_objectSpread({}, context), {}, {
      check: check,
      filter: filter
    }));
  });
}

export default {
  type: type,
  requiresTransaction: true,
  getTriggerAnswers: getTriggerAnswers,

  /**
   * Determines if a Context Sensitive question should be added to the selection purely based on counts.
   */
  selectBasedOnCounts: function () {
    var _selectBasedOnCounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      var survey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              survey = context.survey;

              if (!(context.selection.countByType(type) >= survey.contextSensitive.maximum)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              return _context.abrupt("return", true);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function selectBasedOnCounts(_x) {
      return _selectBasedOnCounts.apply(this, arguments);
    }

    return selectBasedOnCounts;
  }(),

  /**
   * Determines if a Context Sensitive question should be added to the selection, ignoring counts.
   */
  select: function () {
    var _select = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      var survey;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              survey = context.survey; // Apply the indicator rule

              if (passesIndicatorRule(survey.contextSensitive.indicatorRule)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", false);

            case 3:
              return _context2.abrupt("return", applyContextFilters(context));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function select(_x2) {
      return _select.apply(this, arguments);
    }

    return select;
  }(),

  /**
   * Renders a questions Screen
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return otherQuestionUtils.render(context);

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function render(_x3) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    return otherQuestionUtils.parseAnswer(context);
  }
};